import { hideNotification, showNotification } from '@mantine/notifications'
import { DEBUG_MODE, HOST } from './config'
import {
  toTrimmedStringLowerCase,
  isNotNullOrEmptyString,
  isNotNullOrUndefined,
  toTrimmedString,
  uuidv4,
} from './misc'
import { isFrench, isSpanish, translate } from './language'

const USE_CLOSE_BUTTON_ON_TOASTS: boolean = false

export const GET_NOTIFICATIONS_CALLSTRING: string[] = [
  `self.addEventListener('message', async (event) => {
      if (event.data != undefined && event.data != null && event.data.toString().trim() != '') {
        try {
          if (event?.data?.sessionUserId != null && event?.data?.sessionUserId?.toString().trim() != '') {
            const opts = {
              method: 'POST',
              body: JSON.stringify({
                sessionUserId: event.data.sessionUserId.toString().trim(),
              }),
            }
            await fetch('${HOST}' + '/api/p.stream-sv/n/ga', opts)
              .then(async (x) => {
                const ret = await x.json()
                self.postMessage(ret?.notifications?.length > 0 ? ret?.notifications : [])
              })
              .catch((e) => {
                if (${DEBUG_MODE}) console.log(e)
                self.postMessage([])
              })
          } else self.postMessage([])
        } catch (e) {
          if (${DEBUG_MODE}) console.log(e)
          self.postMessage([])
        }
      } else self.postMessage([])
    })`,
]

export async function dismissNotification(notificationId: number) {
  return new Promise<boolean>(async (resolve) => {
    try {
      if (isNotNullOrEmptyString(notificationId)) {
        const urlencoded: URLSearchParams = new URLSearchParams({
          notificationData: JSON.stringify({
            businessNotificationId: toTrimmedString(notificationId),
          }),
        })
        const opts: any = {
          method: 'POST',
          body: urlencoded,
        }
        const resp: any = await fetch(HOST + '/api/p.stream-sv/n/dn', opts)
        await resp
          .json()
          .then((respon: any) =>
            resolve(respon?.success ? respon?.success : false)
          )
          .catch((er: any) => {
            if (DEBUG_MODE) console.log(er)
            resolve(false)
          })
      } else resolve(false)
    } catch (e) {
      if (DEBUG_MODE) console.log(e)
      resolve(false)
    }
  })
}

export async function declineInvitation(pendingInvitation: any) {
  return new Promise<boolean>(async (resolve) => {
    try {
      if (isNotNullOrUndefined(pendingInvitation)) {
        const urlencoded: URLSearchParams = new URLSearchParams({
          invitationData: JSON.stringify({
            invitationToken: toTrimmedString(
              pendingInvitation?.invitationToken
            ),
          }),
        })
        const opts: any = {
          method: 'POST',
          body: urlencoded,
        }
        const resp: any = await fetch(HOST + '/api/p.stream-sv/n/di', opts)
        await resp
          .json()
          .then((respon: any) =>
            resolve(respon?.success ? respon?.success : false)
          )
          .catch((er: any) => {
            if (DEBUG_MODE) console.log(er)
            resolve(false)
          })
      } else resolve(false)
    } catch (e) {
      if (DEBUG_MODE) console.log(e)
      resolve(false)
    }
  })
}

export async function toastWithSubscribeToday(
  message: string,
  dark: boolean,
  subscribeTodayText: string,
  functionRef: any,
  selLang: any,
  viewportWidth: any
) {
  try {
    const id: any = uuidv4()
    showNotification({
      id: id,
      message: (
        <span>
          {toTrimmedString(message)}
          <br />
          <span
            style={{
              color: dark ? '#ffff00' : '#ff10f0',
              cursor: 'pointer',
            }}
            onClick={() => {
              try {
                functionRef()
                hideNotification(id)
              } catch {}
            }}
          >
            {subscribeTodayText}
          </span>
        </span>
      ),
      autoClose: true,
      color: 'cyan',
      style: {
        fontSize: '32px !important',
        fontWeight: 'bold',
        fontFamily: 'Arial, sans-serif',
        height:
          viewportWidth > 419
            ? isFrench(selLang)
              ? '170px'
              : '150px'
            : isFrench(selLang) || isSpanish(selLang)
            ? '150px'
            : '130px',
        zIndex: 932048304394,
      },
      styles: (theme: any) => ({
        outline: '0',
        zIndex: 932048304394,
        description: {
          outline: '0',
          fontSize: '25px',
          color: dark ? '#ffffff' : '#000000',
          [theme.fn.smallerThan(420)]: {
            fontSize: '20px',
          },
          [theme.fn.smallerThan(320)]: {
            fontSize: '16px',
          },
        },
        closeButton: {
          display: USE_CLOSE_BUTTON_ON_TOASTS ? 'initial' : 'none',
          outline: '0',
          backgroundColor: 'transparent',
          color: dark ? '#ffff00' : '#ff10f0',
          transform: 'scale(1.75, 1.75)',
          '&:hover': {
            outline: '0',
            backgroundColor: 'transparent',
            opacity: dark ? 0.85 : 0.5,
          },
        },
        root: {
          zIndex: 932048304394,
          outline: '0',
          border: '2px solid #00aabe',
          backgroundColor: 'transparent',
          webkitBackdropFilter: 'blur(75px) opacity(99%)',
          backdropFilter: 'blur(75px) opacity(99%)',
        },
      }),
    })
    setTimeout(() => {
      try {
        hideNotification(id)
      } catch {}
    }, 3500)
  } catch (e) {
    if (DEBUG_MODE) console.log(e)
  }
}

export async function toastWithUndo(
  message: string,
  level: string,
  dark: boolean,
  undoText: string,
  functionRef: any,
  arg: any
) {
  try {
    const isError: boolean = toTrimmedStringLowerCase(level) == 'error'
    const isSuccess: boolean = toTrimmedStringLowerCase(level) == 'success'
    const isNeutral: boolean = !isError && !isSuccess
    const id: any = uuidv4()
    showNotification({
      id: id,
      message: (
        <span>
          {toTrimmedString(message)}&nbsp;&nbsp;&nbsp;&nbsp;
          <span
            style={{
              color: dark ? '#ffff00' : '#ff10f0',
              cursor: 'pointer',
            }}
            onClick={() => {
              try {
                if (arg != null) functionRef(arg)
                else functionRef()
                hideNotification(id)
              } catch {}
            }}
          >
            {undoText}
          </span>
        </span>
      ),
      autoClose: true,
      color: isNeutral ? 'cyan' : isSuccess ? 'teal' : 'red',
      style: {
        fontSize: '32px !important',
        fontWeight: 'bold',
        fontFamily: 'Arial, sans-serif',
        height: '100px',
        zIndex: 932048304394,
      },
      styles: (theme: any) => ({
        outline: '0',
        zIndex: 932048304394,
        description: {
          outline: '0',
          fontSize: '25px',
          color: theme.colorScheme === 'dark' ? '#ffffff' : '#000000',
          [theme.fn.smallerThan(420)]: {
            fontSize: '20px',
          },
          [theme.fn.smallerThan(320)]: {
            fontSize: '16px',
          },
        },
        closeButton: {
          display: USE_CLOSE_BUTTON_ON_TOASTS ? 'initial' : 'none',
          outline: '0',
          backgroundColor: 'transparent',
          color: theme.colorScheme === 'dark' ? '#ffff00' : '#ff10f0',
          transform: 'scale(1.75, 1.75)',
          '&:hover': {
            outline: '0',
            backgroundColor: 'transparent',
            opacity: theme.colorScheme === 'dark' ? 0.85 : 0.5,
          },
        },
        root: {
          zIndex: 932048304394,
          outline: '0',
          border: isNeutral
            ? '2px solid #00aabe'
            : isSuccess
            ? '2px solid #009368'
            : '1px solid #ff0000',
          backgroundColor: 'transparent',
          webkitBackdropFilter: 'blur(75px) opacity(99%)',
          backdropFilter: 'blur(75px) opacity(99%)',
        },
      }),
    })
    setTimeout(() => {
      try {
        hideNotification(id)
      } catch {}
    }, 3500)
  } catch (e) {
    if (DEBUG_MODE) console.log(e)
  }
}

export async function toast(message: string, level: string) {
  try {
    const isError: boolean = toTrimmedStringLowerCase(level) == 'error'
    const isSuccess: boolean = toTrimmedStringLowerCase(level) == 'success'
    const isNeutral: boolean = !isError && !isSuccess
    showNotification({
      message: toTrimmedString(message),
      color: isNeutral ? 'cyan' : isSuccess ? 'teal' : 'red',
      style: {
        fontSize: '32px !important',
        fontWeight: 'bold',
        fontFamily: 'Arial, sans-serif',
        height: '115px',
        zIndex: 932048304394,
      },
      styles: (theme: any) => ({
        outline: '0',
        zIndex: 932048304394,
        description: {
          outline: '0',
          fontSize: '25px',
          color: theme.colorScheme === 'dark' ? '#ffffff' : '#000000',
          [theme.fn.smallerThan(420)]: {
            fontSize: '20px',
          },
          [theme.fn.smallerThan(320)]: {
            fontSize: '16px',
          },
        },
        closeButton: {
          display: USE_CLOSE_BUTTON_ON_TOASTS ? 'initial' : 'none',
          outline: '0',
          backgroundColor: 'transparent',
          color: theme.colorScheme === 'dark' ? '#ffff00' : '#ff10f0',
          transform: 'scale(1.75, 1.75)',
          '&:hover': {
            outline: '0',
            backgroundColor: 'transparent',
            opacity: theme.colorScheme === 'dark' ? 0.85 : 0.5,
          },
        },
        root: {
          zIndex: 932048304394,
          outline: '0',
          border: isNeutral
            ? '2px solid #00aabe'
            : isSuccess
            ? '2px solid #009368'
            : '1px solid #ff0000',
          backgroundColor: 'transparent',
          webkitBackdropFilter: 'blur(75px) opacity(99%)',
          backdropFilter: 'blur(75px) opacity(99%)',
        },
      }),
    })
  } catch (e) {
    if (DEBUG_MODE) console.log(e)
  }
}

export async function toastSticky(message: string, level: string) {
  try {
    const isError: boolean = toTrimmedStringLowerCase(level) == 'error'
    const isSuccess: boolean = toTrimmedStringLowerCase(level) == 'success'
    const isNeutral: boolean = !isError && !isSuccess
    showNotification({
      autoClose: false,
      message: toTrimmedString(message),
      color: isNeutral ? 'cyan' : isSuccess ? 'teal' : 'red',
      style: {
        fontSize: '32px !important',
        fontWeight: 'bold',
        fontFamily: 'Arial, sans-serif',
        height: '115px',
        zIndex: 932048304394,
      },
      styles: (theme: any) => ({
        outline: '0',
        zIndex: 932048304394,
        description: {
          outline: '0',
          fontSize: '25px',
          color: theme.colorScheme === 'dark' ? '#ffffff' : '#000000',
          [theme.fn.smallerThan(420)]: {
            fontSize: '20px',
          },
          [theme.fn.smallerThan(320)]: {
            fontSize: '16px',
          },
        },
        closeButton: {
          display: 'initial',
          outline: '0',
          backgroundColor: 'transparent',
          color: theme.colorScheme === 'dark' ? '#ffff00' : '#ff10f0',
          transform: 'scale(1.75, 1.75)',
          '&:hover': {
            outline: '0',
            backgroundColor: 'transparent',
            opacity: theme.colorScheme === 'dark' ? 0.85 : 0.5,
          },
        },
        root: {
          zIndex: 932048304394,
          outline: '0',
          border: isNeutral
            ? '2px solid #00aabe'
            : isSuccess
            ? '2px solid #009368'
            : '1px solid #ff0000',
          backgroundColor: 'transparent',
          webkitBackdropFilter: 'blur(75px) opacity(99%)',
          backdropFilter: 'blur(75px) opacity(99%)',
        },
      }),
    })
  } catch (e) {
    if (DEBUG_MODE) console.log(e)
  }
}

export function toastError(selectedLanguage: any) {
  try {
    toast(
      translate('Error.', 'Error.', 'Erreur.', '오류', selectedLanguage),
      'error'
    )
  } catch (e) {
    if (DEBUG_MODE) console.log(e)
  }
}

export const NOTIFICATION_TYPE_ID_WELCOME: number = 1
export const NOTIFICATION_TYPE_ID_FIRST_SUBSCRIBED: number = 2
export const NOTIFICATION_TYPE_ID_SUBSCRIPTION_RENEWED: number = 3
export const NOTIFICATION_TYPE_ID_PAYMENT_SUCCESSFUL: number = 4
export const NOTIFICATION_TYPE_ID_INVITATION_EVENT: number = 5
export const NOTIFICATION_TYPE_ID_DECLINED_INVITATION: number = 6
